export const MAIL_SENT = 201;
